<!-- Mobile (Figma 7652:6424 / 7652:6516): 52px card, r12, neutral-200 border,
     16px padding, flat when closed and ui-shadow-center when open; the content
     owns its own top spacing. -->
<div class="flex flex-col gap-0 md:gap-2">
  <div
    class="flex flex-row justify-between bg-white px-6 py-2 cursor-pointer rounded-[8px] md:shadow-lg max-md:rounded-xl max-md:border max-md:border-solid max-md:p-[15px] max-md:[border-color:var(--color-neutral-200)]"
    [class.ui-shadow-center]="toggle"
    #accordionFace
    (click)="toggleAccordion()"
    (keydown.enter)="toggleAccordion()"
    tabindex="accordion-index"
  >
    <ng-content select="[titleAccordion]"></ng-content>

    <!-- Animated Chevron -->
    <div class="flex cursor-pointer flex-col items-center justify-center">
      <button #buttonSpinner class="flex bg-transparent">
        <ui-icon
          name="chevron-down"
          fill="primary-400"
          size="24"
          mobile-size="20"
        />
      </button>
    </div>
  </div>

  <div #tableOrdersContainer>
    <ng-content select="[contentAccordion]"></ng-content>
  </div>
</div>
